<template>
  <asyncModalButton
    v-bind="$attrs"
    v-on="$listeners"
    :tooltipLabel="tooltipLabel || $t('general.button.delete')"
    :disabled="disabled">
    <template v-slot="{ hasPermission }">
      <b-icon
        icon="delete-forever"
        type="is-danger"
        :class="{'text-access-no-permission': !hasPermission || disabled}"/>
    </template>
  </asyncModalButton>
</template>

<script>
import asyncModalButton from './asyncModalButton';

export default {
  props: {
    tooltipLabel: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  components: {
    asyncModalButton,
  },
};
</script>
